import React from "react";

function RightColumn({ language, text }) {
  return (
    <div className="right">
      <div className="card">
        <h3>{text[language].directionTitle}</h3>
        <p>{text[language].directionP}</p>
        <div>
          <p>Tranvía: líneas 4 y 6</p>
          <p>Buses: 31, 19, 92, 32 y 95</p>
          <p>Metro: parada Serrería/Maritim</p>
        </div>
      </div>
      <div className="card blue">
        <h3>{text[language].stay}</h3>
        <p>{text[language].stayP}</p>
        <a className="cta" href="https://abnb.me/I0jL3gxVJAb">
          {text[language].button}
        </a>
      </div>
      <div></div>
    </div>
  );
}

export default RightColumn;
